module.exports = "https://d2e8d75hhtblx4.cloudfront.net/_next/static/public/static/images/favicon/apple-touch-icon-76x763a36b041ae8a5d1e149471fae88a2081.png";